import { MembersTab as Layout, PEOPLE_TAB } from 'ui-components'

import { MemberList } from './MemberList'
import { GuestList } from './GuestList'
import { MembersTabTools } from './MembersTabTools'
import { useRouter } from 'next/router'
import {
  useGetCurrentWorkspaceGuests,
  useGetCurrentWorkspaceInvitedUsers,
  useGetCurrentWorkspaceMembers
} from '~workspace/queries/useGetWorkspaceById'

const Members = () => {
  const { query, push } = useRouter()

  const members = useGetCurrentWorkspaceMembers()
  const guests = useGetCurrentWorkspaceGuests()
  const invitedUsers = useGetCurrentWorkspaceInvitedUsers()

  const guestInvitedUsers = invitedUsers?.filter(
    (invitedUser) => invitedUser.role === 'guest'
  )
  const memberInvitedUsers = invitedUsers?.filter(
    (invitedUser) => invitedUser.role === 'member'
  )

  return (
    <Layout
      membersCount={members.length + memberInvitedUsers.length}
      guestsCount={guests.length + guestInvitedUsers.length}
      onTabChange={(_, value) =>
        push({ query: { ...query, peopleTab: value } })
      }
      currentTab={(query.peopleTab as PEOPLE_TAB) || PEOPLE_TAB.MEMBERS}
      slots={{
        MembersTabTools,
        MemberList,
        GuestList
      }}
    />
  )
}

export { Members }
